<index-grid data-html2canvas-ignore *ngIf="router.url.indexOf('error') == -1 && router.url.indexOf('payment') == -1 && router.url.indexOf('confirmation') == -1" class="action-bar action-bar__top">
    <index-grid-column size="8" childHorizontalAlignment="left">
        <app-download-button></app-download-button>
    </index-grid-column>
    <index-grid-column size="4" childHorizontalAlignment="right">
      <index-button type="primary"
                    size="full"
                    *ngIf="this.showPayButton"
                    (click)="this.handlePayClick()"
                    class="mx-auto">{{ 'Pay' | transloco }}</index-button>
    </index-grid-column>
</index-grid>

<header class="index-header">
  <div slot="logo-panel" class="index-header__logo">
        <img
            #logo
            *ngIf="(invoicing$ | async)?.merchantLogo !== null && (invoicing$ | async)?.merchantLogo !== ''"
            [alt]="(invoicing$ | async)?.businessName"
            [src]="(invoicing$ | async)?.merchantLogo"
            class="block mx-auto"
        />
    </div>
    <div class="index-header__left-panel">
        <h1 *ngIf="(invoicing$ | async)?.businessName">{{ (invoicing$ | async)?.businessName }}</h1>
    </div>
    <div class="index-header__right-panel">
      <p *ngIf="(accountLocation$ | async)?.phone">
        {{ 'ContactUsCaps' | transloco }}
        <br>
        <b>
          <img alt="Phone icon"
               src="assets/img/icon-phone.svg" />
          {{ (accountLocation$ | async)?.phone }}
        </b>
      </p>
    </div>
</header>

<hr class="primary-brand">
